module.exports = __webpack_public_path__ + "img/water04_selected.a15667ef.png";